import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11fbba81"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bg-white shadow_message mb-5 rounded-3 p-3 p-lg-4"
}
const _hoisted_2 = { class: "justify-content-between align-items-start" }
const _hoisted_3 = { class: "user align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "my-3 fw-bold fs-9 text-center ms-2" }
const _hoisted_7 = {
  key: 1,
  class: "d-flex justify-content-center"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "my-3 fw-bold fs-9 text-center" }
const _hoisted_10 = { class: "position-relative" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "text-break break-spaces p_content" }
const _hoisted_14 = { class: "white-spaces" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "text-break break-spaces" }
const _hoisted_17 = ["href"]

import { computed, ref, watch, nextTick } from 'vue'
import { useStore } from 'vuex'
import { ROOT_STORE } from '@/store/constants'
import { COMMUNITY_STORE } from '@/store/constants'
import { translate } from '@/languages/i18n'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const communityInfo = computed(() => store.getters[COMMUNITY_STORE.GETTERS.COMMUNITY_INFO])
const isMobile = computed(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])
const messageBoardContent = ref<HTMLElement>()
const contentHeight = ref<number>(0)
const fullContent = ref<boolean>(false)
const SeeMore = () => {
  fullContent.value = true
}
const hasUrl = computed(() => {
  let urls: Array<any> = []
  if (communityInfo.value?.message_board_site_url_1) {
    urls.push({
      name: communityInfo.value?.message_board_site_name_1,
      url: communityInfo.value.message_board_site_url_1,
    })
  }
  if (communityInfo.value?.message_board_site_url_2) {
    urls.push({
      name: communityInfo.value?.message_board_site_name_2,
      url: communityInfo.value.message_board_site_url_2,
    })
  }
  if (communityInfo.value?.message_board_site_url_3) {
    urls.push({
      name: communityInfo.value?.message_board_site_name_3,
      url: communityInfo.value.message_board_site_url_3,
    })
  }
  return urls
})

const hasContent = computed(() => {
  return !!communityInfo.value?.message_board_content
})

watch(
  () => communityInfo,
  async () => {
    await nextTick()
    contentHeight.value = messageBoardContent.value?.offsetHeight ?? 0
  },
  {
    deep: true,
    immediate: true,
  }
)

return (_ctx: any,_cache: any) => {
  return (_unref(hasContent))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_unref(isMobile))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("img", {
                    src: require('@/assets/images/message_board_icon_sp.svg')
                  }, null, 8, _hoisted_5),
                  _createElementVNode("h3", _hoisted_6, _toDisplayString(_unref(communityInfo)?.message_board_title), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("img", {
                    src: require('@/assets/images/message_board_icon_pc.svg')
                  }, null, 8, _hoisted_8),
                  _createElementVNode("h3", _hoisted_9, _toDisplayString(_unref(communityInfo)?.message_board_title), 1)
                ])),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                class: "text-break break-spaces real_height position-absolute",
                ref: (_value, _refs) => {
                  _refs['messageBoardContent'] = _value
                  messageBoardContent.value = _value
                },
                innerHTML: _unref(communityInfo)?.message_board_content
              }, null, 8, _hoisted_11),
              (!fullContent.value && (_unref(hasUrl).length || contentHeight.value > 72))
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(communityInfo)?.message_board_content), 1)
                      ])
                    ]),
                    _createElementVNode("span", {
                      class: "text-decoration-underline cursor-pointer text-align-center",
                      onClick: SeeMore
                    }, _toDisplayString(_unref(translate)('seeMore')), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", {
                      class: _normalizeClass({ 'pb-2': _unref(hasUrl).length })
                    }, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(communityInfo)?.message_board_content), 1)
                    ], 2),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(hasUrl), (url, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(['break-all', 'border-top', _unref(hasUrl).length === index + 1 ? 'pt-2' : 'py-2'])
                      }, [
                        _createElementVNode("a", {
                          href: url.url,
                          target: "_blank"
                        }, _toDisplayString(url.name || url.url), 9, _hoisted_17)
                      ], 2))
                    }), 128))
                  ]))
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})